import { ModalNoticeUI } from '@cube3/ui/src/Modal/ModalNoticeUI';
import React, { useCallback, useState } from 'react';
import { useModalActions } from '../../Modals/modalActions';
import { Button } from '@cube3/cubicle/src/core/atoms/Button';
import InputField from '@cube3/cubicle/src/core/atoms/InputField/InputField';
import { useGlobalSubmit } from '@cube3/cubicle/src/helpers/hooks/useGlobalSubmit';

interface Props {
  modalContext: {
    title?: string;
    /** initial value */
    value?: string;
    onSave: (name: string) => void;
  };
}

export const EditNameModal = (props: Props) => {
  const { title = 'Edit name', value, onSave } = props.modalContext;
  const [name, setName] = useState(value || '');

  const { previousModal } = useModalActions();

  const handleChange = useCallback(
    (v) => {
      const val = v ? v.trim() : '';
      setName(val);
    },
    [setName]
  );

  const dirty = name && value !== name?.trim();
  const handleSubmit = useCallback(() => {
    const val = name?.trim();
    if (dirty) {
      onSave(val);
    }
    previousModal();
  }, [name, dirty, onSave]);

  const disabled = !name?.trim();
  useGlobalSubmit(handleSubmit, disabled);

  return (
    <ModalNoticeUI
      title={title}
      onCloseEvent={previousModal}
      footerLeftComponent={<Button label="Cancel" onClick={previousModal} />}
      footerRightComponent={
        <Button
          label={!dirty ? 'Done' : 'Save'}
          disabled={disabled}
          onClick={handleSubmit}
          buttonStyle="solid"
          background="primary"
        />
      }
    >
      <InputField
        onChange={handleChange}
        multiline={1}
        fullwidth
        value={value}
        autoFocus
      />
    </ModalNoticeUI>
  );
};
